import { render, staticRenderFns } from "./HuaxianInfo.vue?vue&type=template&id=4145637e&scoped=true&"
import script from "./HuaxianInfo.vue?vue&type=script&lang=js&"
export * from "./HuaxianInfo.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianInfo.vue?vue&type=style&index=0&id=4145637e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145637e",
  null
  
)

export default component.exports